

import '@angular/platform-browser-dynamic';
import '@angular/platform-browser';
import '@angular/core';
import '@angular/http';
import '@angular/router';

// RxJS

//import 'systemjs';
import 'rxjs';
//var adal = require('adal-angular/lib/adal');
//import 'adal-angular/lib/adal';
//import 'adal-angular/lib/adal.js';
//import 'adal';
//import 'adal-angular';
//import 'adal';
//import 'adal-ang';


import 'jquery';
import 'bootstrap/dist/js/bootstrap';

//import './css/bootstrap.css';
//import './css/bootstrap-theme.css';

import 'bootstrap/dist/css/bootstrap.css';

//require('bootstrap/dist/fonts');
//require('css!bootstrap/dist/css/bootstrap.css');
import '../Content/css/agency.css';
import '../Content/css/loading.css';
import '../node_modules/font-awesome/css/font-awesome.css';

import '../Content/css/icomoon.css';

//import '../node_modules/primeng/resources/themes/omega/theme.css';
import '../node_modules/primeng/resources/primeng.css';
import '../node_modules/primeng/resources/themes/omega/theme.css';
import "../Content/css/primeng-theme/theme.css";

import "jquery-mousewheel/jquery.mousewheel.js";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.js";
//import 'ng2-ripple-directive/dist/css/ripple.css';
//import 'legit-ripple/css/ripple.css';
//import 'legit-ripple/js/ripple.js';
//import 'app/common/ripple.app.js';
//import 'primeui/primeui-ng-all.min.js';

//import '../Content/fonts/';

//var Settings = require('./clientappsettings_js.json');

//var settings  'json-loader!./clientappsettings_js.json';



// WEBPACK FOOTER //
// ./app/vendor.ts